export default "__VITE_ASSET__DRr2cONk__"